import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const DashboardMO = lazy(() => import('../../../../pages/DashboardMO/DashboardMO'));

export const Route = createFileRoute('/$lang/_authenticated/dashboard-mo')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <DashboardMO />
    </Suspense>
  ),
});
